import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  proposalKpis: { loading: false, data: null, error: null },
  proposalreportKpis: { loading: false, data: null, error: null },
  smartsuiteAgreementKpis: { loading: false, data: null, error: null },
};
export const KPISSlice = createSlice({
  name: "smartProposal",
  initialState,
  reducers: {
    requestProposalKpis: (state, action) => {
      state.proposalKpis.loading = true;
      state.proposalKpis.error = null;
    },
    requestProposalKpisSuccess: (state, action) => {
      state.proposalKpis.data = action.payload;
      state.proposalKpis.loading = false;
      state.proposalKpis.error = null;
    },
    requestProposalKpisFaliure: (state, action) => {
      state.proposalKpis.data = null;
      state.proposalKpis.loading = false;
      state.proposalKpis.error = action.payload;
    },
    requestProposalReportKpis: (state, action) => {
      state.proposalreportKpis.loading = true;
      state.proposalreportKpis.error = null;
    },
    requestProposalReportKpisSuccess: (state, action) => {
      state.proposalreportKpis.data = action.payload;
      state.proposalreportKpis.loading = false;
      state.proposalreportKpis.error = null;
    },
    requestProposalReportKpisFaliure: (state, action) => {
      state.proposalreportKpis.data = null;
      state.proposalreportKpis.loading = false;
      state.proposalreportKpis.error = action.payload;
    },
    // smartsuite agreement list kpis
    fetchSmartSuiteAgreementKpisRequest: (state, action) => {
      state.smartsuiteAgreementKpis.loading = true;
      state.smartsuiteAgreementKpis.error = null;
    },
    fetchSmartSuiteAgreementKpisSuccess: (state, action) => {
      state.smartsuiteAgreementKpis.data = action.payload;
      state.smartsuiteAgreementKpis.loading = false;
      state.smartsuiteAgreementKpis.error = null;
    },
    fetchSmartSuiteAgreementKpisFailure: (state, action) => {
      state.smartsuiteAgreementKpis.data = null;
      state.smartsuiteAgreementKpis.loading = false;
      state.smartsuiteAgreementKpis.error = action.payload;
    },
  },
});
export const {
  requestProposalKpis,
  requestProposalKpisSuccess,
  requestProposalKpisFaliure,
  requestProposalReportKpis,
  requestProposalReportKpisSuccess,
  requestProposalReportKpisFaliure,
  fetchSmartSuiteAgreementKpisRequest,
  fetchSmartSuiteAgreementKpisSuccess,
  fetchSmartSuiteAgreementKpisFailure,
} = KPISSlice.actions;
export const getProposalKpisData = (state) => {
  return state.kpis.proposalKpis;
};
export const getProposalReportKpisData = (state) => {
  return state.kpis.proposalreportKpis;
};

export const getSmartSuiteAgreementKpisState= (state) => {
  return state?.kpis?.smartsuiteAgreementKpis;
};
export default KPISSlice.reducer;
